import React, { memo } from "react";
import { Message } from "views/agent/chat/types";
import { SingleMessage } from "../../SingleMessage";

function sortMessages(messages: Message[]): Message[] {
  return [...messages].sort((a, b) => {
    const dateA = new Date(a.created_at).getTime();
    const dateB = new Date(b.created_at).getTime();
    if (dateA !== dateB) {
      return dateA - dateB;
    }
    if (a.role === "USER" && b.role !== "USER") return -1;
    if (a.role !== "USER" && b.role === "USER") return 1;
    return 0;
  });
}

export const MessageList: React.FC<{
  messages?: Message[];
}> = memo(({ messages = [] }) => {
  const sortedMessages = sortMessages(messages);
  return (
    <>
      {sortedMessages.map((message, index) => (
        <SingleMessage
          isLast={index === sortedMessages.length - 1}
          key={message.id}
          message={message.content}
          time={message.created_at}
          isUser={message.role === "USER"}
          references={message.references}
          extra={
            message.role === "USER"
              ? "bg-blue-500 text-white rounded-l-xl rounded-br-xl"
              : "bg-gray-100 dark:bg-gray-700 rounded-r-xl rounded-bl-xl"
          }
          timecolor={
            message.role === "USER"
              ? "text-blue-100"
              : "text-gray-500 dark:text-gray-400"
          }
        />
      ))}
    </>
  );
});
MessageList.displayName = "MessageList";
